document.addEventListener('DOMContentLoaded', function() {
  const commentForm = document.getElementById('commentForm');
  const fullName = document.getElementById('fullName');
  const email = document.getElementById('email');
  const title = document.getElementById('title');
  const comment = document.getElementById('comment');
  const ratingInputs = document.querySelectorAll('input[name="rating"]');
  const formError = document.querySelector('.form-error');
  const submitButton = document.querySelector('.submit-button');
  const productGidField = document.getElementById('productGid');

  // Sonuç mesaj alanları
  const formContainer = document.getElementById('commentFormContainer');
  const successMessage = document.getElementById('commentSuccess');
  const errorMessage = document.getElementById('commentError');
  const errorMessageText = document.getElementById('errorMessage');

  // Modal elementleri
  const modalOverlay = document.querySelector('.comment-modal-overlay');
  const modal = document.querySelector('.comment-modal');
  const closeButton = document.querySelector('.comment-modal-close');

  // Form durumu (başlangıçta normal)
  let formState = 'normal'; // normal, loading, success, error

  // Görsel yükleme ile ilgili elementler
  const imageUpload = document.getElementById('imageUpload');
  const imageUploadButton = document.querySelector('.image-upload-button');
  const selectedImages = document.querySelector('.selected-images');

  // Görsel hata durumunu takip etmek için değişken
  let hasImageError = false;

  // Modal kapatma fonksiyonu
  function closeModal() {
    if (modalOverlay && modal) {
      // Modal sınıflarını kaldır
      modalOverlay.classList.remove('active');
      modal.classList.remove('active');

      // Body'den modal-open sınıfını kaldır
      document.body.classList.remove('modal-open');

      // Formu sıfırla
      if (commentForm) {
        commentForm.reset();
      }

      // Hata mesajlarını temizle
      if (formError) {
        formError.innerHTML = '';
      }

      // Görsel hatası durumunu sıfırla
      hasImageError = false;

      // Seçili görselleri temizle
      if (selectedImages) {
        selectedImages.innerHTML = '';
      }

      // Form alanlarındaki hata sınıflarını kaldır
      if (fullName) fullName.classList.remove('error');
      if (email) email.classList.remove('error');
      if (title) title.classList.remove('error');
      if (comment) comment.classList.remove('error');

      // Form durumunu normal hale getir
      updateFormState('normal');

      // Buton metnini orijinal haline getir
      if (submitButton) {
        submitButton.textContent = 'GÖNDER';
      }
    }
  }

  // Kapatma düğmesine tıklama olayı
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Modal overlay'e tıklama olayı (dışarıya tıklandığında kapatma)
  if (modalOverlay) {
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        closeModal();
      }
    });
  }

  // Görsel yükleme işlemleri
  if (imageUploadButton) {
    imageUploadButton.addEventListener('click', function() {
      imageUpload.click();
    });
  }

  if (imageUpload) {
    imageUpload.addEventListener('change', function() {
      if (!selectedImages) return;

      selectedImages.innerHTML = '';
      if (formError) formError.innerHTML = '';
      hasImageError = false;

      if (this.files.length > 4) {
          // Maksimum 4 dosya uyarısı
          const errorMessage = document.createElement('div');
          errorMessage.className = 'image-error';
          errorMessage.textContent = `${this.files.length} medya dosyası seçildi (maksimum 4)`;
          selectedImages.appendChild(errorMessage);

          // Hata mesajını göster
          if (formError) {
            const errorElement = document.createElement('p');
            errorElement.textContent = 'Maksimum 4 görsel veya video yükleyebilirsiniz.';
            formError.appendChild(errorElement);
          }

          // Hata durumunu ayarla
          hasImageError = true;

          // Input değerini temizle
          this.value = '';

          // Butonu devre dışı bırak
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('disabled');
          }
      } else if (this.files.length < 1) {
          // Dosya seçilmedi, bir şey yapma
      } else {
          const imageCount = document.createElement('div');
          imageCount.className = 'image-count';
          imageCount.textContent = `${this.files.length} medya dosyası seçildi`;
          selectedImages.appendChild(imageCount);

          // Form alanlarını kontrol et
          checkAllFields();
      }
    });
  }

  // İlk yüklendiğinde butonu devre dışı bırak
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.classList.add('disabled');
  }

  // Tüm alanları kontrol et ve butonu güncelle
  function checkAllFields() {
      if (!fullName || !email || !title || !comment || !submitButton) return;

      // Form başarılı veya işlem sürecinde ise doğrulamayı atla
      if (formState === 'success' || formState === 'loading') return;

      const isFullNameValid = fullName.value.trim() !== '';
      const isEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isEmailValid = email.value.trim() !== '' && isEmailRegex.test(email.value.trim());
      const isTitleValid = title.value.trim() !== '';
      const isCommentValid = comment.value.trim() !== '';

      let isRatingValid = false;
      ratingInputs.forEach(input => {
          if (input.checked) {
              isRatingValid = true;
          }
      });

      // Eğer görsel hatası varsa form geçerli değil
      if (hasImageError) {
          submitButton.disabled = true;
          submitButton.classList.add('disabled');
          return;
      }

      if (isFullNameValid && isEmailValid && isTitleValid && isCommentValid && isRatingValid) {
          submitButton.disabled = false;
          submitButton.classList.remove('disabled');
          if (formError) formError.innerHTML = '';
      } else {
          submitButton.disabled = true;
          submitButton.classList.add('disabled');

          // Sadece puan eksikse ve diğer alanlar doluysa hata mesajı göster
          if (isFullNameValid && isEmailValid && isTitleValid && isCommentValid && !isRatingValid && formError) {
              formError.innerHTML = '';
              const errorElement = document.createElement('p');
              errorElement.textContent = 'Lütfen puan seçiniz.';
              formError.appendChild(errorElement);
          } else if (!hasImageError && formError) {
              // Görsel hatası yoksa ve diğer hatalar varsa içeriği temizle
              formError.innerHTML = '';
          }
      }
  }

  // Input validasyonu
  function validateInput(input) {
      if (!input) return false;

      if (!input.value.trim()) {
          input.classList.add('error');
          return false;
      } else {
          input.classList.remove('error');
          return true;
      }
  }

  // Email validasyonu
  function validateEmail(input) {
      if (!input) return false;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!input.value.trim() || !emailRegex.test(input.value.trim())) {
          input.classList.add('error');
          return false;
      } else {
          input.classList.remove('error');
          return true;
      }
  }

  // Her hangi bir değişiklikte tüm alanları kontrol et
  if (fullName) fullName.addEventListener('input', checkAllFields);
  if (email) email.addEventListener('input', checkAllFields);
  if (title) title.addEventListener('input', checkAllFields);
  if (comment) comment.addEventListener('input', checkAllFields);

  // Rating seçim kontrolü
  ratingInputs.forEach(input => {
      input.addEventListener('change', checkAllFields);
  });

  // Input blur event handlers
  if (fullName) {
    fullName.addEventListener('blur', function() {
        validateInput(fullName);
    });
  }

  if (email) {
    email.addEventListener('blur', function() {
        validateEmail(email);
    });
  }

  if (title) {
    title.addEventListener('blur', function() {
        validateInput(title);
    });
  }

  if (comment) {
    comment.addEventListener('blur', function() {
        validateInput(comment);
    });
  }

  // Sayfa yüklendiğinde kontrol et
  checkAllFields();

  // Form durumunu güncelleme fonksiyonu
  function updateFormState(state, message = '') {
    if (!formError || !submitButton) return;

    formState = state;
    formError.innerHTML = '';

    // Duruma göre form veya sonuç mesajlarını göster
    if (state === 'success') {
      // Başarı mesajını göster, formu gizle
      if (formContainer) formContainer.style.display = 'none';
      if (successMessage) successMessage.style.display = 'flex';
      if (errorMessage) errorMessage.style.display = 'none';
    } else if (state === 'error') {
      // Hata mesajını göster, formu gizle
      if (formContainer) formContainer.style.display = 'none';
      if (successMessage) successMessage.style.display = 'none';
      if (errorMessage) errorMessage.style.display = 'flex';

      // Asıl hata mesajını konsola yaz
      if (message) {
        console.error('Form gönderim hatası:', message);
      }

      // Hata mesajı metnini standart yapıya güncelle
      if (errorMessageText) {
        errorMessageText.textContent = 'Bir hata oluştu. Lütfen tekrar deneyiniz.';
      }
    } else {
      // Form modunu göster, sonuç mesajlarını gizle
      if (formContainer) formContainer.style.display = 'block';
      if (successMessage) successMessage.style.display = 'none';
      if (errorMessage) errorMessage.style.display = 'none';

      // Form içinde mesaj gösterme
      if (message) {
        const messageElement = document.createElement('p');
        messageElement.textContent = message;

        if (state === 'loading') {
          messageElement.classList.add('loading-message');
        }

        formError.appendChild(messageElement);
      }
    }

    // Buton durumunu güncelle
    if (state === 'loading') {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
      submitButton.textContent = 'İŞLENİYOR...';
    } else if (state === 'success') {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
      submitButton.textContent = 'GÖNDERİLDİ';
    } else if (state === 'error') {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
      submitButton.textContent = 'TEKRAR GÖNDER';
    } else {
      submitButton.textContent = 'GÖNDER';
      checkAllFields(); // Normal durumda alanları kontrol et
    }
  }

  // Yorum gönderme AJAX fonksiyonu
  async function submitCommentForm(formData) {
    try {
      // Form durumunu yükleniyor olarak güncelle
      updateFormState('loading', 'Yorumunuz işleniyor, lütfen bekleyiniz...');

      // Seçili rating değerini al
      let rating = 0;
      ratingInputs.forEach(input => {
        if (input.checked) {
          rating = parseInt(input.value);
        }
      });

      // Seçili topic değerlerini al
      const topicCheckboxes = document.querySelectorAll('input[name="topics[]"]:checked');
      const selectedTopics = Array.from(topicCheckboxes).map(checkbox => checkbox.value);

      // Ürün GID'sini al
      let productId = '';
      if (productGidField && productGidField.value) {
        productId = productGidField.value.trim();
      }

      // FormData nesnesi oluştur - her durumda multipart/form-data kullanacağız
      const apiFormData = new FormData();

      // Form alanlarını FormData'ya ekle
      apiFormData.append('user_name', fullName ? fullName.value.trim() : '');
      apiFormData.append('email', email ? email.value.trim() : '');

      // Products alanını sadece productId boş değilse ekle
      if (productId) {
        apiFormData.append('products', JSON.stringify([productId]));
      }

      apiFormData.append('rating', rating.toString());
      apiFormData.append('subjects', JSON.stringify(selectedTopics));
      apiFormData.append('text', comment ? comment.value.trim() : '');
      apiFormData.append('title', title ? title.value.trim() : '');

      // Medya dosyalarını ekle (varsa)
      if (imageUpload && imageUpload.files.length > 0) {
        // Maksimum 4 dosya kontrolü
        const filesCount = Math.min(imageUpload.files.length, 4);
        for (let i = 0; i < filesCount; i++) {
          apiFormData.append('media', imageUpload.files[i]);
        }
      }

      console.log('Gönderilen form verisi:', {
        user_name: fullName ? fullName.value.trim() : '',
        email: email ? email.value.trim() : '',
        products: productId,
        rating: rating,
        subject: selectedTopics.join(', '),
        text: comment ? comment.value.trim() : '',
        title: title ? title.value.trim() : '',
        mediaCount: imageUpload ? imageUpload.files.length : 0
      }); // Debug için

      // API isteğini multipart/form-data olarak gönder
      const response = await fetch('https://createcomment-extqcjsdea-uc.a.run.app', {
        method: 'POST',
        body: apiFormData, // headers otomatik olarak multipart/form-data olarak ayarlanacak
      });

      // Yanıtı işle
      const data = await response.json();

      if (response.ok) {
        // Başarılı yanıt
        updateFormState('success');
        // Form alanlarını temizle ama modalı kapatma
        if (commentForm) commentForm.reset();
      } else {
        // API'den hata yanıtı
        throw new Error(data.message || 'Yorumunuz kaydedilirken bir hata oluştu.');
      }
    } catch (error) {
      // Detaylı hata mesajını console'a yaz (debug için)
      console.error('Yorum gönderme hatası:', error);

      // Kullanıcıya sadece genel bir hata mesajı göster
      updateFormState('error', 'Lütfen daha sonra tekrar deneyiniz.');
    }
  }

  // Form submit handler
  if (commentForm) {
    commentForm.addEventListener('submit', function(e) {
        e.preventDefault(); // Her durumda normal form gönderimini engelle

        // Eğer form zaten işlemde veya başarılı ise tekrar gönderme
        if (formState === 'loading') return;

        let isValid = true;

        // Ad Soyad kontrolü
        if (!validateInput(fullName)) {
            isValid = false;
        }

        // Email kontrolü
        if (!validateEmail(email)) {
            isValid = false;
        }

        // Başlık kontrolü
        if (!validateInput(title)) {
            isValid = false;
        }

        // Yorum kontrolü
        if (!validateInput(comment)) {
            isValid = false;
        }

        // Son bir kez tüm alanları kontrol et
        checkAllFields();

        if (isValid && submitButton && !submitButton.disabled) {
            // Formu AJAX ile gönder
            submitCommentForm(new FormData(commentForm));
        }
    });
  }
});